/**
 * Checks if there is a current value in the background image block support
 * attributes.
 *
 * @param {Object} style                            Style attribute.
 * @param          style.background
 * @param          style.background.backgroundImage
 * @return {boolean}     Whether the block has a background image value set.
 */
export function hasBackgroundImageValue( style?: {
	readonly background?: {
		readonly backgroundImage?:
			| {
					readonly id?: number;
					readonly url?: string;
			  }
			| string;
	};
} ): boolean {
	return (
		// Supports url() string values in theme.json.
		'string' === typeof style?.background?.backgroundImage ||
		!! style?.background?.backgroundImage?.id ||
		!! style?.background?.backgroundImage?.url
	);
}
